import { useEffect, useRef } from "react"

import * as services from "../services"

const SAVE_THROTTLE_MS = 10000
const INIT_GRACE_MS = 1500

// Leading+trailing throttle: the first change after being idle saves immediately (so a
// change made right before logout isn't lost), then opens a cooldown window. Changes during
// the cooldown are held and sent once at the end of it, which then re-opens the cooldown. If
// nothing changes before a cooldown ends, the throttle goes idle and the next change saves
// immediately again.
export const useUpdatePreferences = (featureName, data) => {
  const isReady = useRef(false)
  const latestDataRef = useRef(data)
  const featureNameRef = useRef(featureName)
  const cooldownIdRef = useRef(null)
  const hasPendingRef = useRef(false)

  featureNameRef.current = featureName

  useEffect(() => {
    const timer = setTimeout(() => {
      isReady.current = true
    }, INIT_GRACE_MS)

    return () => clearTimeout(timer)
  }, [])

  useEffect(
    () => () => {
      clearTimeout(cooldownIdRef.current)
      if (hasPendingRef.current) {
        hasPendingRef.current = false
        services.updateUserPreference(featureNameRef.current, latestDataRef.current)
      }
    },
    []
  )

  useEffect(() => {
    latestDataRef.current = data
    if (!isReady.current || data == null) return

    if (cooldownIdRef.current) {
      hasPendingRef.current = true
      return
    }

    const save = () => services.updateUserPreference(featureName, latestDataRef.current)
    const startCooldown = () => {
      cooldownIdRef.current = setTimeout(() => {
        if (hasPendingRef.current) {
          hasPendingRef.current = false
          save()
          startCooldown()
        } else {
          cooldownIdRef.current = null
        }
      }, SAVE_THROTTLE_MS)
    }

    save()
    startCooldown()
  }, [featureName, data])
}
